var _clipPath, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgISun(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.0 0.0 960.0 720.0",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0l960.0 0l0 720.0l-960.0 0l0 -720.0z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m0 0l960.0 0l0 720.0l-960.0 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m171.3699 475.1837c-61.917664 -146.16422 -2.7921448 -313.68286 139.05847 -393.99033c141.85062 -80.30748 323.75198 -49.244095 427.81735 73.05858c104.06537 122.30269 98.98773 299.0511 -11.9422 415.69806c-110.92999 116.64691 -294.34003 138.10034 -431.36572 50.456665l185.0622 -264.9421z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m171.3699 475.1837c-61.917664 -146.16422 -2.7921448 -313.68286 139.05847 -393.99033c141.85062 -80.30748 323.75198 -49.244095 427.81735 73.05858c104.06537 122.30269 98.98773 299.0511 -11.9422 415.69806c-110.92999 116.64691 -294.34003 138.10034 -431.36572 50.456665",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 24,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeDasharray: "72.0,96.0,0.0,96.0",
    d: "m171.3699 475.1837c-61.917664 -146.16422 -2.7921448 -313.68286 139.05847 -393.99033c141.85062 -80.30748 323.75198 -49.244095 427.81735 73.05858c104.06537 122.30269 98.98773 299.0511 -11.9422 415.69806c-110.92999 116.64691 -294.34003 138.10034 -431.36572 50.456665",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m314.56693 360.0l0 0c0 -91.36615 74.066925 -165.43307 165.43307 -165.43307l0 0c43.87555 0 85.9541 17.429504 116.97882 48.454224c31.02472 31.02472 48.454224 73.10327 48.454224 116.97885l0 0c0 91.36615 -74.066895 165.43304 -165.43304 165.43304l0 0c-91.36615 0 -165.43307 -74.066895 -165.43307 -165.43304z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 3.677165354330709,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m314.56693 360.0l0 0c0 -91.36615 74.066925 -165.43307 165.43307 -165.43307l0 0c43.87555 0 85.9541 17.429504 116.97882 48.454224c31.02472 31.02472 48.454224 73.10327 48.454224 116.97885l0 0c0 91.36615 -74.066895 165.43304 -165.43304 165.43304l0 0c-91.36615 0 -165.43307 -74.066895 -165.43307 -165.43304z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m426.86615 170.41733l53.13385 -91.90552l53.13385 91.90552z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 12,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m426.86615 170.41733l53.13385 -91.90552l53.13385 91.90552z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m673.2808 302.33072l91.90552 53.13385l-91.90552 53.13385z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 12,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m673.2808 302.33072l91.90552 53.13385l-91.90552 53.13385z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m533.13385 549.5827l-53.13385 91.90546l-53.13385 -91.90546z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 12,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m533.13385 549.5827l-53.13385 91.90546l-53.13385 -91.90546z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m286.71915 408.59842l-91.9055 -53.13385l91.9055 -53.13385z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 12,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m286.71915 408.59842l-91.9055 -53.13385l91.9055 -53.13385z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m584.04816 190.07692l102.55121 -27.40158l-27.401611 102.55119z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 12,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m584.04816 190.07692l102.55121 -27.40158l-27.401611 102.55119z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m308.84857 260.44l-27.40158 -102.55118l102.55118 27.40158z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 12,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m308.84857 260.44l-27.40158 -102.55118l102.55118 27.40158z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m376.33502 536.1672l-102.55118 27.40155l27.40158 -102.55115z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 12,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m376.33502 536.1672l-102.55118 27.40155l27.40158 -102.55115z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m658.81287 451.28177l27.40155 102.55118l-102.55115 -27.40155z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 12,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m658.81287 451.28177l27.40155 102.55118l-102.55115 -27.40155z",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgISun);
export default __webpack_public_path__ + "static/media/ISun.4e93761ca6802daf6e788bf1699f68db.svg";
export { ForwardRef as ReactComponent };